module.exports = __webpack_public_path__ + "static/media/img3.d27f9871.png";